import { domainConfig, findSetup } from "./customDomains";
import { mutator } from "./mutator";

export const removeCustomDomain = mutator({
  ...domainConfig,
  description: "Removes a custom domain from public workflow URLs.",
  interactionType: "delete",
  fn: async ({ tx, ctx, args }) => {
    const setup = await findSetup(tx, ctx.tenantId, args);
    if (setup)
      await tx.mutate.customDomainSetups.update({
        id: setup.id,
        status: "removing",
        enabled: false,
        lastError: null,
        updatedAt: Date.now(),
      });
  },
});
